'use strict';
import {ReduxItem} from '../../../_libs/redux-observable-list';
import {buildInstanceSyncNotifier} from '../../../auth/utils/redux-lists';
import {BASE_REDUX_LIST_OPTIONS} from '../../../config/redux-list';
import {ASSET_COLLECTION} from '../../../assets/domain/config';
import {getAssetReduxItem} from '../reducers/state';
import {ASSET_ITEM_PREFIX} from './state';
import {logger} from './logger';


export const itemPath = id => `${ASSET_COLLECTION}/${id}`;

/** @type {ReduxObservableItemOptions} */
const reduxItemOptions = {
  prefix: ASSET_ITEM_PREFIX,
  crossDomain: BASE_REDUX_LIST_OPTIONS.crossDomain,
  getToken: BASE_REDUX_LIST_OPTIONS.getToken,
  baseApiUrl: BASE_REDUX_LIST_OPTIONS.baseApiUrl,
  baseServerUrl: BASE_REDUX_LIST_OPTIONS.baseServerUrl,
  getState: getAssetReduxItem,
  itemPath,
  itemSyncPath: itemPath,
  syncNotifier: buildInstanceSyncNotifier(ASSET_COLLECTION),

  logger,
};

export const assetReduxItem = new ReduxItem(reduxItemOptions);



// WEBPACK FOOTER //
// ./src/js/app/model/redux/assetReduxItem.js